import { createAction, createSlice } from "@reduxjs/toolkit";

const getTotalReviewUserSlice = createSlice({
  name: "getTotalReviewUser",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getTotalReviewUserSlice;
const getTotalReviewUserAction = createAction(name);

export {
  getTotalReviewUserAction,
  actions as getTotalReviewUserActions,
  reducer as getTotalReviewUserReducer,
};
